
		<ng-progress></ng-progress>
		<header>
			<img id="logo" src="./assets/images/logo_fit.png" routerLink="/login"/>
		</header>
		<div class="wrap">
			<router-outlet></router-outlet>
		</div>
	